import {DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledBudgetCard = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 4}px;
        border-radius: 8px;
        border: 1px solid ${palette.neutral[200]};
        display: flex;
        flex-direction: column;
        gap: ${spacing * 3}px;
        height: max-content;
    `
)

export const StyledBudgetCardSection = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        background-color: ${palette.neutral[50]};
        padding: ${spacing * 1.5}px ${spacing * 3}px;
        border-radius: 8px;
        & > div {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: ${spacing * 1.5}px;
        }
    `
)

export const StyledDeleteBudgetContent = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[600]};
        & b {
            font-weight: 500;
        }
        & ul {
            list-style-type: disc;
            padding-left: ${spacing * 3}px;
        }
        & li {
            margin-left: ${spacing * 3}px;
        }
    `
)

export const StyledDeleteBudgetFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)
